import { apiClient } from "@/lib/api-client";
import type { ApiKey, CreateApiKeyRequest, CreateApiKeyResponse } from "./types";

export const apiKeysApi = {
  list: () => apiClient.get<ApiKey[]>("/v1/api-keys"),

  create: (data: CreateApiKeyRequest) =>
    apiClient.post<CreateApiKeyResponse>("/v1/api-keys", data),

  rotate: (id: string) =>
    apiClient.post<CreateApiKeyResponse>(`/v1/api-keys/${id}/rotate`, {}),

  revoke: (id: string) =>
    apiClient.delete<void>(`/v1/api-keys/${id}`),
};
